import useLocaleLink from 'hooks/useLocaleLink';

interface RelatedArticlesProps {
  title: string;
  articles: { title: string; href: string }[];
}

export default function RelatedArticles({ title, articles }: RelatedArticlesProps) {
  const localeLink = useLocaleLink();

  return (
    <div className="flex flex-col gap-4 pad:gap-6">
      <h2 className="text-lg font-bold leading-[26px] text-base-label pad:text-xl pad:leading-[30px]">{title}</h2>
      <ul className="flex flex-col gap-4">
        {articles.map((article) => (
          <li key={article.href}>
            <a
              href={`${localeLink}${article.href}`}
              className="text-sm font-medium leading-5 text-base-primary transition-colors hover:opacity-80 pad:text-md pad:font-normal pad:leading-6 pad:text-base-label pad:hover:text-base-primary pad:hover:opacity-100"
            >
              {article.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
